export default "__VITE_ASSET__D1Mx1Gjd__"